/**
 * Token management utilities for localStorage
 */

const TOKEN_KEY = 'auth_token'

/**
 * Get token from localStorage
 */
export const getToken = (): string | null => {
  try {
    return localStorage.getItem(TOKEN_KEY)
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error getting token from localStorage:', error)
    return null
  }
}

/**
 * Store token in localStorage
 */
export const setToken = (token: string): void => {
  try {
    localStorage.setItem(TOKEN_KEY, token)
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error storing token in localStorage:', error)
  }
}

/**
 * Remove token from localStorage
 */
export const removeToken = (): void => {
  try {
    localStorage.removeItem(TOKEN_KEY)
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error removing token from localStorage:', error)
  }
}

/**
 * Get Authorization header value
 */
export const getAuthHeader = (): string | null => {
  const token = getToken()
  return token ? `Bearer ${token}` : null
}
